
import { RouterEnum } from "@/router/router.enums";

export const localeRouterUtils = (locale) => {
  const localePathMapping = {
    zh: {
      [RouterEnum.Dashboard.path]: `${RouterEnum.DentIssueCertificate.path}/zh`,
      [RouterEnum.DentIssueCertificate.path]: `${RouterEnum.DentIssueCertificate.path}/zh`,
      [RouterEnum.DentEditCertificateContents.path]: `${RouterEnum.DentEditCertificateContents.path}/zh`,
    },
    ja: {
      [RouterEnum.Dashboard.path]: `${RouterEnum.DentIssueCertificate.path}/ja`,
      [RouterEnum.DentIssueCertificate.path]: `${RouterEnum.DentIssueCertificate.path}/ja`,
      [RouterEnum.DentEditCertificateContents.path]: `${RouterEnum.DentEditCertificateContents.path}/ja`,
    },
    // Add more locales as needed
  };

  return {
    getLocaleRedirect: (path) => {
      if (localePathMapping[locale] && localePathMapping[locale][path]) {
        return localePathMapping[locale][path];
      }
      return null;
    },
  };
};